<template>
  <PrioritySlaStateBadge v-if="live" :state="live.state" :test-id="testId">{{
    text
  }}</PrioritySlaStateBadge>
  <span v-else class="text-xs text-neutral50" :data-testid="`${testId}-missing`">—</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type {
  PrioritySlaDto,
  PrioritySlaThresholds
} from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { formatSlaChipText, resolveLiveSla } from '../slaFormat'
import PrioritySlaStateBadge from './PrioritySlaStateBadge.vue'

/**
 * Chip do estado (M3): ícone + rótulo; Urgente/Atenção com "· 13 min";
 * Estourado com "+2h42"; Concluído com a hora (Antecipe pago: "Concluído · Antecipe
 * pago", sem hora — A1 25/09). O ESTADO anda no tique
 * (`nowMs` + limiares); a etapa só muda no refresh de 60 s (A26).
 */
const props = withDefaults(
  defineProps<{
    sla: PrioritySlaDto | null
    nowMs?: number | null
    thresholds?: PrioritySlaThresholds | null
    testId?: string
  }>(),
  { nowMs: null, thresholds: null, testId: 'priority-sla-chip' }
)

const live = computed(() =>
  props.sla ? resolveLiveSla(props.sla, props.nowMs, props.thresholds) : null
)

const text = computed(() =>
  live.value && props.sla
    ? formatSlaChipText(live.value, props.sla.completedAt, props.nowMs, props.sla.completedBy)
    : ''
)
</script>
